import { InsuranceType, MainPath } from "Constants/constants";

export const PRODUCT_PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.CABIN}`;

export enum CabinStandards {
  VERY_HIGH = "VERY_HIGH",
  HIGH = "HIGH",
  NORMAL = "NORMAL",
  LOWER = "LOWER",
}

export const CONSTRUCTION_YEAR_LIMIT = 1900;
export const CONSTRUCTION_YEAR_LIMIT_SUPER = 1985;
export const MAX_GROSS_AREA = 300;

export const DEFAULT_DEDUCTIBLE_CABIN = "8000";
